import React from "react";

import { CircleNotch } from "~/Icon";
import * as Layout from "~/Layout";

export const Component: Component = ({ children }) => (
  <>
    <Layout.Inline.Component right>
      <Icon.Component />
    </Layout.Inline.Component>
    {children ?? "Loading..."}
  </>
);

export namespace Icon {
  export const Component = () => <CircleNotch spin faded />;
}
